import { Icon } from "./Icon.js";
import { fmt } from "../lib/money.js";
import type { KidBundle } from "../api/me.js";

const TYPE_TO_ICON: Record<string, string> = {
  allowance: "piggy",
  interest: "sparkle",
  chores: "check",
  gift: "sparkle",
  withdrawal: "minus",
  deposit: "plus",
  transfer: "transfer",
  adjustment: "settings",
};

export interface TxnRowProps {
  t: KidBundle["recentTxns"][number];
}

export function TxnRow({ t }: TxnRowProps) {
  const iconName = TYPE_TO_ICON[t.type] ?? "coin";
  const pos = t.amountCents > 0;
  return (
    <div className="txn-row">
      <div
        className="txn-icon-wrap"
        style={{
          color: pos ? "var(--pos)" : "var(--neg)",
          background: pos ? "oklch(0.95 0.03 155)" : "oklch(0.95 0.03 27)",
        }}
      >
        <Icon name={iconName} size={18} />
      </div>
      <div>
        <div style={{ fontSize: 14, fontWeight: 500 }}>{t.note}</div>
        <div className="soft" style={{ fontSize: 12, textTransform: "capitalize" }}>
          {t.type} ·{" "}
          {new Date(t.date).toLocaleDateString("en-US", { month: "short", day: "numeric" })}
        </div>
      </div>
      <div className={`money money-sm ${pos ? "money-pos" : "money-neg"}`}>
        {fmt(t.amountCents, { showSign: true })}
      </div>
    </div>
  );
}
